import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@clerk/clerk-react";
import LoadingScreen from "../components/loadingScreen";
import { UserProvider } from "../context/UserContext";
import { routeEndpoints } from "./routeEndpoints";

export default function ProtectedRoute() {
  const { isLoaded, isSignedIn } = useAuth();

  if (!isLoaded) {
    return <LoadingScreen />;
  }

  if (!isSignedIn) {
    return <Navigate to={routeEndpoints.login} replace />;
  }

  return (
    <UserProvider>
      <Outlet />
    </UserProvider>
  );
}
